export var MAX_PRODUCTS = 5;
export var MIN_PRODUCTS = 5;
export var getPlaceholdersQty = function getPlaceholdersQty(funds, min) {
  return MAX_PRODUCTS - funds.length;
};